type BrandMarkProps = {
  className?: string;
};

export function BrandMark({ className = "" }: BrandMarkProps) {
  return <img aria-hidden="true" className={`brand-mark${className ? ` ${className}` : ""}`} src="/brand/chew-mark.svg" />;
}
